module.exports = __webpack_public_path__ + "img/meeting.60a54f53.webp";